module.exports = __webpack_public_path__ + "static/wealth-and-poverty-of-nations-2eb6ac076a19c89e0c1e29a15fe006a7.jpg";